import Axios from 'axios'
import humps from 'humps'

// トークンkey値の設定
const SHEETA_LOCALE_KEY = 'x-sheeta-locale'
const DEFAULT_CONTENT_TYPE = 'application/json'
const REQUEST_TIME_OUT = 600000

export default class ApiClient {
  constructor () {
    this.client = Axios.create({
      baseURL: process.env.VUE_APP_API_HOST,
      timeout: REQUEST_TIME_OUT
    })

    /**
     * Snakelize Request
     */
    this.client.interceptors.request.use(request => {
      if (request.headers['Content-Type'] === 'application/json') {
        request.data = humps.decamelizeKeys(request.data)
      }
      return Promise.resolve(request)
    })

    /**
     * Camelize Response
     */
    this.client.interceptors.response.use(
      response => {
        const contentType = response.headers['Content-Type']
          ? response.headers['Content-Type']
          : response.headers['content-type']
        if (contentType && (contentType.indexOf('application/json') >= 0 || contentType.indexOf('application/json') >= 0)) {
          response.data = humps.camelizeKeys(response.data)
        }
        return Promise.resolve(response)
      }
    )

    /**
     * handle data property
     */
    this.client.interceptors.response.use(
      response => {
        return Promise.resolve(response.data)
      },
      error => {
        switch (error.response.status) {
          case 400:
            return Promise.reject(error.response.data)
          case 401:
            return Promise.reject(error.response.data)
            // }
            // break
          case 403:
            // 403時はいかなる場合も403ページ
            return Promise.reject(error.response.data)
            // location.href = '/forbidden'
            // break
          case 404:
            // 404時はいかなる場合も404ページ
            return Promise.reject(error.response.data)
            // location.href = '/not-found'
            // break
          case 500:
            // 500時はいかなる場合も500ページ
            return Promise.reject(error.response.data)
            // location.href = '/internal-server-error'
            // break
          case 503:
            // 503時はいかなる場合も503ページ
            return Promise.reject(error.response.data)
            // location.href = '/maintenance'
            // break
          default:
            return Promise.reject(error.response.data)
        }
      }
    )
  }

  /**
   * トークンをヘッダーにマージする
   * @param {*} header
   */
  addTokenToHeader (config) {
    const defaultHeader = {
      'Content-Type': DEFAULT_CONTENT_TYPE,
      [SHEETA_LOCALE_KEY]: navigator.language.slice(0, 2)
    }
    if (!config) {
      // なにもない場合はデフォルトの値を返却
      return { headers: defaultHeader }
    } else if (config.headers) {
      // header指定がある場合は指定を優先してマージ
      config.headers = { ...defaultHeader, ...config.headers }
    } else {
      config.headers = defaultHeader
    }
    return config
  }

  /**
   * クエリパラメータをconfigにマージ
   */
  addQueryParams (config, params = {}) {
    const queryParams = {}
    const decamelizeParams = humps.decamelizeKeys(params)
    for (const key in decamelizeParams) {
      if (decamelizeParams[key] !== null && decamelizeParams[key] !== '') {
        queryParams[key] = decamelizeParams[key]
      }
    }
    if (!config) {
      return { params: queryParams }
    } else {
      config.params = queryParams
      return config
    }
  }

  get (apiPath, body = null, config = null) {
    config = this.addQueryParams(config, body)
    return this.client.get(apiPath, this.addTokenToHeader(config))
  }

  post (apiPath, body = null, config = null) {
    return this.client.post(apiPath, body, this.addTokenToHeader(config))
  }

  patch (apiPath, body = null, config = null) {
    return this.client.patch(apiPath, body, this.addTokenToHeader(config))
  }

  put (apiPath, body = null, config = null) {
    return this.client.put(apiPath, body, this.addTokenToHeader(config))
  }

  delete (apiPath, body = null, config = null) {
    config = this.addQueryParams(config, body)
    return this.client.delete(apiPath, this.addTokenToHeader(config))
  }
}
